import { ListMarkerStyleName } from '../../slate-api/types/elements/List';
import { indexToLatin, indexToRoman } from '../../util/number-formatting';

export const ORDERED_LIST_STYLES = new Set<ListMarkerStyleName>([
  ListMarkerStyleName.DECIMAL,
  ListMarkerStyleName.DECIMAL_LEADING_ZERO,
  ListMarkerStyleName.DECIMAL_SECTION,
  ListMarkerStyleName.LOWER_LATIN,
  ListMarkerStyleName.LOWER_ROMAN,
  ListMarkerStyleName.UPPER_LATIN,
  ListMarkerStyleName.UPPER_ROMAN,
]);

export function formatListMarker(
  index: number,
  styleName: ListMarkerStyleName | undefined
): string {
  if (!styleName) return '';

  switch (styleName) {
    case ListMarkerStyleName.DECIMAL:
      return String(index + 1);
    case ListMarkerStyleName.DECIMAL_LEADING_ZERO:
      return String(index + 1).padStart(2, '0');
    case ListMarkerStyleName.LOWER_LATIN:
      return indexToLatin(index, false);
    case ListMarkerStyleName.UPPER_LATIN:
      return indexToLatin(index, true);
    case ListMarkerStyleName.LOWER_ROMAN:
      return indexToRoman(index, false);
    case ListMarkerStyleName.UPPER_ROMAN:
      return indexToRoman(index, true);
    default:
      return '';
  }
}
